import fetch from 'cross-fetch';
import { print } from 'graphql/language/printer';

import { tosaToken, anonymousId } from '@farmersdog/lead-browser-storage';

import config from '../config';

/** Using this nested import syntax decreases bundle size by 168kb */

import type { DocumentNode } from 'graphql';

export const anonymousIdHeaderKey = 'tfd-anonymous-id';

export interface GraphQLResponse<D> {
  data: D | null;
  errors: GraphQLErrorResponse[] | null;
}

export interface GraphQLErrorResponse {
  message: string;
  path: string[];
  locations: ErrorLocation[];
  extensions: ErrorExtensions;
}

export interface ErrorLocation {
  line: number;
  column: number;
}

export interface ErrorExtensions {
  code: string;
  status: number;
  statusCode: number;
}

interface SendTosaRequestArgs<V> {
  query: DocumentNode;
  variables: V;
  headers?: Record<string, unknown>;
}

interface TFDHeaders {
  Authorization?: string;
  'tfd-anonymous-id': string;
}

export async function sendTosaRequest<V, D>({
  query,
  variables,
  headers: additionalHeaders,
}: SendTosaRequestArgs<V>): Promise<GraphQLResponse<D>> {
  const token = tosaToken.get();
  const headers: TFDHeaders = {
    'tfd-anonymous-id': anonymousId.get(),
    Authorization: token ? `Bearer ${token}` : '',
  };

  const result = await fetch(`${config.get('app.tosaUrl')}/graphql`, {
    method: 'POST',
    body: JSON.stringify({
      query: print(query),
      variables,
    }),
    headers: {
      'Content-Type': 'application/json',
      ...headers,
      ...additionalHeaders,
    },
  });

  if (result.status >= 300) {
    throw new Error(`Request failed with status code: ${result.status}`);
  }

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  return (await result.json()) as GraphQLResponse<D>;
}
